import { render, staticRenderFns } from "./UptimeMatrix.vue?vue&type=template&id=79da552e&scoped=true"
import script from "./UptimeMatrix.vue?vue&type=script&lang=js"
export * from "./UptimeMatrix.vue?vue&type=script&lang=js"
import style0 from "./UptimeMatrix.vue?vue&type=style&index=0&id=79da552e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79da552e",
  null
  
)

export default component.exports